import { api } from '@/services/api/main/axios';
import { useWorkspace } from '@/composables/useWorkspace';

export const getLandingsApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('landings', { params });
  return res.data.payload;
};

export type GetLandingsListParams = {
  search?: string;
  status?: string;
  limit?: string | number;
  orderBy?: string;
  orderDirection?: string;
  columns?: string[];
  countryId?: number;
  workspaceId?: string;
  tagsOff?: number;
};

export const getLandingsListApiRequest = async (
  params: GetLandingsListParams,
): Promise<unknown[]> => {
  const { workspaceId, ...rest } = params;
  const workspaceApi = useWorkspace();
  const requestParams: Record<string, unknown> = {
    ...rest,
    workspaceIds: [...new Set([workspaceId, ...workspaceApi.allPublicWorkspacesIds.value])],
  };
  return getLandingsApiRequest(requestParams);
};

export const getLandingApiRequest = async (id: string): Promise<Record<string, unknown>> => {
  const res = await api.get<{ payload: Record<string, unknown> }>(`landings/${id}`);
  return res.data.payload;
};

export const postCreateLandingApiRequest = async (
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.post<{ payload: Record<string, unknown> }>('landings', payload);
  return res.data.payload;
};

export const putUpdateLandingApiRequest = async (
  id: string,
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.put<{ payload: Record<string, unknown> }>(`landings/${id}`, payload);
  return res.data.payload;
};

export const putLandingsBulkUpdateApiRequest = async (
  workspaceId: string,
  payload: object,
): Promise<void> => {
  await api.put(`landings/workspace/${workspaceId}/bulk-update`, payload);
};

export const getLandingsCountApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<{ count: number }> => {
  const res = await api.get<{ payload: { count: number } }>('landings/count', { params });
  return res.data.payload;
};

export const postLandingsImportApiRequest = async (payload: object): Promise<void> => {
  await api.post('landings/import', payload);
};
